var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCroix(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "13px",
    height: "13px",
    viewBox: "0 0 13 13",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Accueil",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Desktop-HD-Copy-11",
    transform: "translate(-886.000000, -828.000000)",
    stroke: "#FFFFFF",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(886.941406, 829.000000)"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "Path-2-Copy-5",
    transform: "translate(5.500000, 8.494629) scale(1, -1) translate(-5.500000, -8.494629) ",
    points: "0 5.74462891 5.5 11.2446289 11 5.74462891"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path-2-Copy-6",
    transform: "translate(5.655762, 2.750000) scale(1, -1) rotate(-180.000000) translate(-5.655762, -2.750000) ",
    points: "0.155761719 0 5.65576172 5.5 11.1557617 0"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCroix);
export default __webpack_public_path__ + "static/media/croix.7eab157fdd589763fdc8cd3aff7e2574.svg";
export { ForwardRef as ReactComponent };